























































import { ILocale } from "@/@types/locale";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import InputSearch from "@/components/app/search/input-search.vue";

interface ICat {
  _id: string;
  name: ILocale;
}

@Component({ components: { InputSearch } })
export default class StandartCategoryDd extends Vue {
  @Prop({ type: Array, default: () => [] }) categoryList!: ICat[];
  @Prop({ type: Boolean, default: true }) full!: boolean;
  @Prop({ type: String, default: "" }) categoryID!: string;
  @Prop({ type: String, default: "Category.name" }) name!: string;
  @Prop({ type: String, default: "primary" }) variant!: string;
  activeCategory = this.categoryID;
  search = "";

  get categorys(): ICat[] {
    return this.categoryList.filter((item) => {
      if (item.name)
        return (
          this.$getLocale(item.name)
            .toLowerCase()
            .indexOf(this.search.toLowerCase()) > -1
        );
    });
  }

  @Watch("categoryID")
  updateCat(): void {
    this.activeCategory = this.categoryID;
  }

  get getCategoryName(): string {
    const cat = this.categoryList.find(
      (cat: ICat) => cat._id === this.activeCategory
    );
    return cat ? this.$getLocale(cat.name) : "";
  }
}
